<template>
	<div style="width: 100%;height: 100%;">
		<el-image style="width: 100%; height:auto;margin-top: 30px;" v-for="(item, index) in url" :key="index" :src="item" :preview-src-list="url"></el-image>
	</div>
</template>

<script>
export default {
	props: {
		url: Array
	},
	data() {
		return {

			answer: ['https://img0.baidu.com/it/u=3119542616,1165410720&fm=26&fmt=auto','https://img0.baidu.com/it/u=1985782942,2642646797&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=333','https://img0.baidu.com/it/u=2866200409,4132400541&fm=253&fmt=auto&app=120&f=JPEG?w=450&h=780']
		};
	},
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/homes/errors/components/picture.vue